import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import cx from 'classnames'

const Phaser = ({
  className = '',
  color,
  inDark,
  label,
  fontSize,
  fontWeight,
  offset,
  upperCase,
  noBottom,
}) => {
  if (label === undefined) {
    throw new Error('Phaser should not be rendered without a label')
  }
  let offsetValue

  if (typeof offset === 'number') offsetValue = offset + 'px'
  else if (typeof offset === 'string') offsetValue = offset

  return (
    <Typography
      className={cx({ [className]: !!className, inDark: !!inDark }, 'phaser')}
      variant="headline"
      style={{
        fontWeight: fontWeight || 300,
        fontSize: fontSize || '1.5em',
        color: color || '#285978',
        ...(offsetValue
          ? { margin: `${offsetValue} auto ${noBottom ? 0 : offsetValue}` }
          : { marginBottom: !!noBottom && 0 }),
        visibility: label ? 'visibile' : 'hidden',
        textTransform: upperCase ? 'uppercase' : 'none',
      }}
    >
      {label}
      <style>{`
        .phaser {
          display: flex;
          flex-basis: 100%;
          align-items: center;
          margin: 8px 0px;
        }
        .phaser::after {
          content: "";
          flex-grow: 1;
          background: rgba(0, 0, 0, 0.08);
          height: 1px;
          font-size: 0px;
          line-height: 0px;
          margin: 0px 8px;
        }
        .inDark::after {
          background: #5d90af;
        }
        @media screen and (max-width: 600px) {
          .phaser {
            font-size: 1.4em !important;
          }
        }
      `}</style>
    </Typography>
  )
}

Phaser.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  upperCase: PropTypes.bool,
}

export default Phaser



// WEBPACK FOOTER //
// ./src/components/Phaser.js